import { api } from './client';

export type AdminUserStatus = 'ACTIVE' | 'BLOCKED' | 'PENDING_VERIFICATION';

export interface AdminUserDto {
  id: string;
  email: string;
  nick: string;
  role: 'USER' | 'ADMIN';
  active: boolean;
  status: AdminUserStatus;
  blockedAt: string | null;
  createdAt: string;
}

export type AdminInvitationType = 'ROOM_LINK' | 'ROOM_USER';

export interface AdminInvitationDto {
  id: string;
  type: AdminInvitationType;
  code: string | null;
  email: string | null;
  roomId: string;
  roomName: string | null;
  invitedBy: string;
  invitedByNick: string | null;
  inviteeUserId: string | null;
  inviteeNick: string | null;
  expiresAt: string;
  createdAt: string;
  expired: boolean;
  used: boolean;
}

export interface AdminRoomDto {
  id: string;
  name: string;
  emoji: string | null;
  type: 'PRIVATE' | 'PUBLIC';
  ownerId: string;
  ownerNick: string | null;
  memberCount: number;
  createdAt: string;
}

export const adminApi = {
  listUsers: () => api.get<AdminUserDto[]>('/admin/users'),
  promoteUser: (id: string) => api.post<AdminUserDto>(`/admin/users/${id}/promote`),
  demoteUser: (id: string) => api.post<AdminUserDto>(`/admin/users/${id}/demote`),
  blockUser: (id: string) => api.post<AdminUserDto>(`/admin/users/${id}/block`),
  unblockUser: (id: string) => api.post<AdminUserDto>(`/admin/users/${id}/unblock`),
  resendUserVerification: (id: string) => api.post<void>(`/admin/users/${id}/resend-verification`),
  deleteUser: (id: string) => api.delete<void>(`/admin/users/${id}`),

  listInvitations: () => api.get<AdminInvitationDto[]>('/admin/invitations'),
  deleteInvitation: (id: string) => api.delete<void>(`/admin/invitations/${id}`),
  cleanupExpiredInvitations: () =>
    api.post<{ removed: number }>('/admin/invitations/cleanup-expired'),

  listRooms: () => api.get<AdminRoomDto[]>('/admin/rooms'),
};
